import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    isAem: false,
    isAppLoading: true,
    isConfigInitialized: false,
    errorPageType: undefined,
    languageCode: undefined,
    swMessage: undefined,
    hwContainerIds: [],
    isWelcomeAnimationStarted: false,
    isWelcomeAnimationFinished: false,
    pendingReturnFromWebAppConnection: false,
    pendingReturnActionId: null,
};

export const slice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        setLayout: (state, action) => {
            state.layout = action.payload;
        },
        setIsAem: (state, action) => {
            state.isAem = action.payload;
        },
        setIsAppLoaded: (state, action) => {
            state.isAppLoading = action.payload;
        },
        setIsConfigInitialized: (state, action) => {
            state.isConfigInitialized = action.payload;
        },
        logoutClearData: (state, action) => {
            return state;
        },
        setLanguageCode: (state, action) => {
            state.languageCode = action.payload;
        },
        setSwMessage: (state, action) => {
            state.swMessage = action.payload;
        },
        clearSwMessage: (state, action) => {
            state.swMessage = undefined;
        },
        setHwContainerId: (state, action) => {
            state.hwContainerIds.push(action.payload);
        },
        clearHwContainerId: (state, action) => {
            state.hwContainerIds = state.hwContainerIds.filter((id) => id !== action.payload);
        },
        setIsWelcomeAnimationStarted: (state, action) => {
            state.isWelcomeAnimationStarted = action.payload;
        },
        setIsWelcomeAnimationFinished: (state, action) => {
            state.isWelcomeAnimationFinished = action.payload;
        },
        setPendingReturnFromWebAppConnection: (state, action) => {
            state.pendingReturnFromWebAppConnection = action.payload;
        },
        setPendingReturnActionId: (state, action) => {
            state.pendingReturnActionId = action.payload || null;
        },
        clearPendingReturnActionId: (state) => {
            state.pendingReturnActionId = null;
        },
    },
});

export const {
    setLayout,
    setIsAem,
    setIsAppLoaded,
    setIsConfigInitialized,
    logoutClearData,
    setLanguageCode,
    setSwMessage,
    clearSwMessage,
    setHwContainerId,
    clearHwContainerId,
    setIsWelcomeAnimationStarted,
    setIsWelcomeAnimationFinished,
    setPendingReturnFromWebAppConnection,
    setPendingReturnActionId,
    clearPendingReturnActionId,
} = slice.actions;

export default slice.reducer;
